<div class="col-12">{{ security.description }}</div>
<div class="col-12" *ngIf="security.proxyError">
	{{ security.proxyIdentifier }}<span dcrHTMLKey="BPAS_PROXY_SECURITY_RESOLUTION_ERROR"> - This Aladdin identifier is unavailable.</span>
</div>
<div class="col-12" *ngIf="!security.proxyError"><span dcrHTMLKey="RISK_PROXY_ISIN_PREFIX">Proxy: </span>{{ security.proxyDescription }}</div>
